const getters = {
    getProducts: (state) => {
        return _.toArray(state.products)
    },
    getSortedProducts:(state) => (sortOrder) => {
        return _.sortBy(state.products,['productNumber'],[ sortOrder])
    },
    getProductNPC: (state) => (id, workflowId = null) => {
        let product = state.products[id]
        if (workflowId) {
            try {
                return product.npcMetaPerWorkflow[workflowId]
            } catch (e) {
                throw (e)
            }
        } else {
            return product.npcMeta
        }

    },
    getProduct: (state) => (id) => {
        return state.products[id] ? state.products[id] : null
    },

    /**
     * Get all properties from products
     * Convert all properties [array, array, array] to one array (flatMapDeep)
     * Map only the name from the newly created array (_map)
     * Remove duplicates with _uniq
     * @param state
     * @param getters
     * @returns {Array}
     */
    getProductPropertiesAutocomplete: (state, getters) => {
        return _.uniq(_.map(_.flatMapDeep(getters.getProducts, 'properties'), 'name'));
    }
};
export default getters
